module.exports = __webpack_public_path__ + "static/media/11.e5dd2d07.jpg";